<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import useWorkflow from '@/composables/useWorkflow.ts';
import type { SheetProps } from '@/types';
import type { WorkflowGroup } from '@/types/api';

const props = defineProps<
    SheetProps & {
        workflowGroups: WorkflowGroup[];
    }
>();

const { start } = useWorkflow();

async function startWorkflow(handle: string, title: string) {
    props.close();
    await start(handle, title);
}
</script>

<template>
    <div class="space-y-1">
        <p class="p font-bold">Was möchten Sie heute tun?</p>
        <p class="p-small text-muted-foreground">
            Der Assistent führt Sie durch häufige Aufgaben.
        </p>
    </div>

    <div class="p-small mt-6 space-y-6">
        <Card
            v-for="group in workflowGroups"
            :key="group.id"
        >
            <CardHeader>
                <CardTitle class="font-semibold">{{ group.title }}</CardTitle>
            </CardHeader>
            <CardContent>
                <ul
                    class="divide-y leading-none *:py-2 *:first:pt-0 *:last:pb-0"
                >
                    <li
                        v-for="workflow in group.workflows"
                        :key="workflow.id"
                    >
                        <Button
                            variant="link"
                            class="font-normal"
                            @click="
                                () =>
                                    startWorkflow(
                                        workflow.handle,
                                        workflow.title
                                    )
                            "
                            >{{ workflow.title }}</Button
                        >
                    </li>
                </ul>
            </CardContent>
        </Card>
    </div>
</template>
